import naja from 'naja';
import Modal from 'bootstrap.native/src/components-v4/modal-native';

export default class ModalExtension {
	constructor(naja) {
		this.name = "modal-naja";

		naja.addEventListener('init', (e) => {
			const modal = document.querySelector('[data-modal-show]');
			if (modal !== null) {
				this.showModal(modal.id);
			}

			const showModal = document.querySelector('[data-show-modal]');
			if (showModal !== null) {
				this.showModal(showModal.dataset['showModal']);
			}
		});

		naja.addEventListener('success', (e) => {
			if (e.response.hideModal) {
				let modalId = e.response.hideModal;
				this.hideModal(modalId);
			}

			if (e.response.showModal) {
				let modalId = e.response.showModal;
				if (!this.isVisible(modalId)) {
					this.showModal(modalId);
				}
			}

		});
	}

	hideModal(modalId) {
		if (typeof Modal !== undefined) {
			let modal = new Modal(this.getModalElement(modalId));
			modal.hide();
		} else if (typeof $ !== undefined) {
			let modal = this.getJqueryElement(modalId);
			modal.modal('hide');
		}
	}

	showModal(modalId) {
		if (typeof Modal !== undefined) {
			let modal = new Modal(this.getModalElement(modalId));
			modal.show();
		} else if (typeof $ !== undefined) {
			let modal = this.getJqueryElement(modalId);
			modal.modal('show');
		}
	}

	getJqueryElement(modalName) {
		if (!modalName.startsWith('#')) {
			modalName = '#' + modalName;
		}

		return $(modalName);
	}

	getModalElement(modalName) {
		if (!modalName.startsWith('#')) {
			modalName = '#' + modalName;
		}

		return document.querySelector(modalName);
	}

	isVisible(modalId) {
		const modal = document.getElementById(modalId);
		return modal && (modal.classList.contains('show') || modal.classList.contains('in'));
	}
}